import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';
import { TaskStatusOptions } from 'modules/constants';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonIcon, WhiteButtonWithIcon } from 'styledComponents/buttons';
import { exportToExcel } from 'utils/exportToExcel';

import excelIcon from '../../../assets/img/icons/excel-green.svg';
import BottomPagination from '../../../components/Pagination/BottomPagination/BottomPagination';
import TopPagination from '../../../components/Pagination/TopPagination/TopPagination';
import {
  CommonFlex,
  CommonGrid,
  HeaderContainer,
  PageTitle,
} from '../../../styledComponents/common';
import DeleteTaskModal from '../DeleteTaskModal';
import SubTasksList from './SubTasksList';
import SubTaskFilter from './subTaskFilter';
import SubTaskDetailsContainer from '../SubTaskDetails/subTaskDetailsContainer';



const SubTasks = ({
  selectedOrganization,
  getOrganizationMembersList,
  orgMembersList,
  loadingTaskAssigneeId,
  isLoading,
  officesShortList,
  getOfficesShortList,
  getSubTasks,
  subTasksList,
  deleteTask,
  deletedCallback,
  deleteIsLoading,
  createdTaskInfo,
  createTask,
  // pagination
  totalTasksCount,
  pageSize,
  history,
  locationsList,
  getTaskLocation,
  getPublicZoneList,
  publicZoneList,
  defaultSubTasks,
  getDefaultSubTasks,
  match,
  getMainTaskList,
  mainTaskList,
  getEmtithalMasterTasks,
  emtithalMasterTasksList,
  exportAllSubtaskPublicZoneReport,
  exportAllSubtaskPublicZoneReportLoading,
}) => {
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const subTaskId = match?.params?.id || urlParams.get('id');
  const statusFromParams = urlParams.get('status');
  const zoneFromParams = urlParams.get('zone');
  if (statusFromParams || zoneFromParams) {
    const newUrl = `${window.location.pathname}`;
    window.history.replaceState({}, '', newUrl);
  }

  const [selectedDate, setSelectedDate] = useState({
    startDate:
      statusFromParams || zoneFromParams
        ? moment('2024-04-01')
        : moment().startOf('year'),
    endDate: moment().endOf('year'),
  });
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState({
    label: 'all_locations',
    value: null,
  });

  const [selectedMember, setSelectedMember] = useState('');
  const [taskStatus, setTaskStatus] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [search, setSearch] = useState(false);
  const [currentSearchedTerm, setCurrentSearchedTerm] = useState('');
  const [expandedTaskId, setExpandedTaskId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [taskIdDelete, setTaskIdDelete] = useState(null);
  const [subTaskReportLoading, setSubTaskReportLoading] = useState(false);


  // pagination
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [selectedPublicZone, setSelectedPublicZone] = useState('');
  const [selectedSubTask, setSelectedSubTask] = useState();
  const [subTaskCode, setSubTaskCode] = useState('');

  // Add a state to track if "All Offices" is selected
  const [selectAllOffices, setSelectAllOffices] = useState(false);
  // Toggle filters
  const [notUpdatedSince5Days, setNotUpdatedSince5Days] = useState(false);
  const [notUpdatedAtAll, setNotUpdatedAtAll] = useState(false);
  const [selectedMainTask, setSelectedMainTask] = useState({
    label: 'all_tasks',
    value: null,
  });

  const allStatusOption = useMemo(() => ({ label: t('all_status'), value: null }), [t]);
  const allLocationsOption = useMemo(() => ({ label: t('all_locations'), value: null }), [t]);
  const allPublicZonesOption = useMemo(() => ({ label: t('all_public_zones'), value: null }), [t]);
  const allOfficesOption = useMemo(() => ({ label: t('all_offices'), value: null }), [t]);
  const allSubTasksOption = useMemo(() => ({ label: t('all_sub_tasks'), value: null }), [t]);
  const allTasksOption = useMemo(() => ({ label: t('all_tasks'), value: null }), [t]);

  const currentOffice = useMemo(
    () => (selectedOffice?.value === null || !selectedOffice ? allOfficesOption : selectedOffice),
    [selectedOffice, allOfficesOption],
  );
  const currentStatus = useMemo(
    () => (taskStatus?.value === null || !taskStatus ? allStatusOption : taskStatus),
    [taskStatus, allStatusOption],
  );
  const currentPublicZone = useMemo(
    () =>
      selectedPublicZone?.value === null || !selectedPublicZone
        ? allPublicZonesOption
        : selectedPublicZone,
    [selectedPublicZone, allPublicZonesOption],
  );
  const currentLocation = useMemo(
    () => (selectedLocation?.value === null || !selectedLocation ? allLocationsOption : selectedLocation),
    [selectedLocation, allLocationsOption],
  );
  const currentSubTask = useMemo(
    () => (selectedSubTask?.value === null || !selectedSubTask ? allSubTasksOption : selectedSubTask),
    [selectedSubTask, allSubTasksOption],
  );
  const currentMainTask = useMemo(
    () => (selectedMainTask?.value === null || !selectedMainTask ? allTasksOption : selectedMainTask),
    [selectedMainTask, allTasksOption],
  );
  const statusOptions = TaskStatusOptions?.map(option => ({
    ...option,
    label: t(option.key),
  }));

  const onPublicZoneChange = useCallback(e => {
    setSelectedPublicZone(e);
    setSelectedLocation(allLocationsOption);
    setSelectedSubTask(allSubTasksOption);
  }, [allLocationsOption, allSubTasksOption]);
  const onSubTaskChange = e => {
    setSelectedSubTask(e);
  };
  const selectLocation = e => {
    setCurrentPageNumber(1);
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setSelectedLocation(e);
  };
  useEffect(() => {
    statusFromParams
      ? statusOptions.map(statusOption => {
        if (statusOption.key === statusFromParams) {
          setTaskStatus(statusOption);
        }
      })
      : setTaskStatus({
        label: t('all_status'),
        value: null,
      });
    zoneFromParams &&
      statusOptions.map(statusOption => {
        if (statusOption.key === statusFromParams) {
          setTaskStatus(statusOption);
        }
      });
    getTaskLocation();
    getPublicZoneList();
    getMainTaskList();
  }, []);


  //useeffect to get main tasks when public zone changes
  useEffect(() => {
    if (selectedPublicZone?.value) {
      getMainTaskList({
        public_zone_id: selectedPublicZone.value,
      });
    }
  }, [selectedPublicZone]);

  useEffect(() => {
    if (selectedPublicZone?.value) {
      getDefaultSubTasks({
        public_zone_id: selectedPublicZone.value,
      });
    } else getDefaultSubTasks();
    if (selectedPublicZone?.value) {
      getOfficesShortList({
        public_zone_id: selectedPublicZone.value,
      });
    }
  }, [selectedPublicZone]);

  useEffect(() => {
    if (!selectedOffice) {
      zoneFromParams
        ? officesShortList.map(office => {
          if (office.name === zoneFromParams) {
            setSelectedOffice({
              label: office.name,
              value: office.id,
            });
          }
        })
        : setSelectedOffice(allOfficesOption);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (deletedCallback) {
      getSubTasks({
        startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
        endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
        page: currentPageNumber,
      });
    }
  }, [deletedCallback]);

  useEffect(() => {
    if (createdTaskInfo) {
      getSubTasks({
        startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
        endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
        page: currentPageNumber,
      });
    }
  }, [createdTaskInfo]);
  const handleSearchByName = () => {
    setCurrentSearchedTerm(searchTerm);
    setSearch(!search);
    setCurrentPageNumber(1);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setSearch(!search);
  };

  const handlePageChange = page => {
    setCurrentPageNumber(page);
  };

  const selectOffice = e => {
    setCurrentPageNumber(1);
    setSearchTerm('');
    setCurrentSearchedTerm('');

    // Check if "All Offices" is selected
    if (e.value === 'all') {
      setSelectAllOffices(true);
      // Create an "All Offices" option that will be used in the filter UI
      setSelectedOffice({
        label: t('all_offices'),
        value: null, // Use null to indicate all offices in the API call
        isAllOffices: true, // Flag to indicate this is the "All Offices" option
      });
    } else {
      setSelectAllOffices(false);
      setSelectedOffice(e);
    }

    setSelectedLocation({
      label: t('all_locations'),
      value: null,
    });
  };

  const selectMember = person => {
    setSelectedMember(person);
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setCurrentPageNumber(1);
  };

  const clearMember = () => {
    setSelectedMember('');
    setSearchTerm('');
    setCurrentSearchedTerm('');
    setCurrentPageNumber(1);
  };

  const onSearchTermChange = e => {
    const { value } = e.target;
    if (value !== '') {
      setSelectedMember('');
    }
    setSearchTerm(value);
  };

  const handleStatusChange = e => {
    setTaskStatus(e);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const toggleDeleteModal = taskId => {
    setIsOpen(!isOpen);
    if (taskId) {
      setTaskIdDelete(taskId);
    }
  };

  const handleDeleteTask = () => {
    if (taskIdDelete) {
      const payload = {
        task_id: taskIdDelete,
      };
      deleteTask(payload);
      toggleDeleteModal();
    }
  };
  const handleExportToExcel = async (type) => {
    const payload = {
      startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
      page: currentPageNumber,
    };
    if (selectedOffice && selectedOffice.value) {
      payload.office_id = selectedOffice.value;
    }
    if (selectedPublicZone && selectedPublicZone.value) {
      payload.public_zone_name = selectedPublicZone.label;
    }
    if (selectedSubTask && selectedSubTask.code) {
      payload.default_sub_task_code = selectedSubTask.code;
    }
    if (selectedLocation && selectedLocation.value) {
      payload.location_id = selectedLocation.value;
    }
    if (selectedMember && selectedMember.id) {
      payload.assignee_id = selectedMember.id;
    }
    if (searchTerm && searchTerm.trim()) {
      payload.task_name = searchTerm.toLowerCase().trim();
    }
    if (taskStatus && taskStatus.value && taskStatus.value !== 'all') {
      payload.status = taskStatus.value;
    }
    if (notUpdatedSince5Days) {
      payload.not_updated_since_days = 5;
    }
    if (notUpdatedAtAll) {
      payload.not_updated_at_all = notUpdatedAtAll;
    }

    // Remove null or undefined properties
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v != null),
    );

    if (filteredPayload.startDate && filteredPayload.endDate) {
      const url = `albait/export/sub-task-report/?required_start_date=${filteredPayload.startDate
        }&required_end_date=${filteredPayload.endDate}${filteredPayload.page ? `&page=${filteredPayload.page}` : ''
        }${filteredPayload.task_name?.length > 0
          ? `&name=${filteredPayload.task_name}`
          : ''
        }${filteredPayload.office_id
          ? `&office_id=${filteredPayload.office_id}`
          : ''
        }${filteredPayload.public_zone_name
          ? `&public_zone_name=${filteredPayload.public_zone_name}`
          : ''
        }${filteredPayload.default_sub_task_code
          ? `&default_sub_task_code =${filteredPayload.default_sub_task_code}`
          : ''
        }${filteredPayload.location_id
          ? `&location_id=${filteredPayload.location_id}`
          : ''
        }${filteredPayload.assignee_id
          ? `&assignees=${filteredPayload.assignee_id}`
          : ''
        }${filteredPayload.status ? `&status=${filteredPayload.status}` : ''}${filteredPayload.approval_status
          ? `&approval_status=${filteredPayload.approval_status}`
          : ''
        }${filteredPayload.not_updated_since_days ? `&not_updated_since_days=${filteredPayload.not_updated_since_days}` : ''}${filteredPayload.not_updated_at_all ? `&not_updated_at_all=${filteredPayload.not_updated_at_all}` : ''}`;

      if (type === "subtasks") {
        setSubTaskReportLoading(true);
      } else {
        setSubTaskReportLoading(true);
      }
      try {
        const response = await exportToExcel(url, null, true);
      } catch (error) {
        console.log('🚀 ~ handleExportToExcel ~ error:', error);
      }

      if (type === "subtasks") {
        setSubTaskReportLoading(false);
      } else {
        setSubTaskReportLoading(false);
      }
    }
  };

  const handleExportOfficeSubtaskReport = () => {
    // Prevent action if export is disabled or already loading
    if (isOfficeExportDisabled() || exportAllSubtaskPublicZoneReportLoading) {
      return;
    }
    
    const payload = {};
    if (selectedPublicZone && selectedPublicZone.value) {
      payload.public_zone_id = selectedPublicZone.value;
    }
    if (selectedOffice && selectedOffice.value) {
      payload.office_id = selectedOffice.value;
    }
    exportAllSubtaskPublicZoneReport(payload);
  };

  const isOfficeExportDisabled = () => {
    return !selectedPublicZone?.value || !selectedOffice?.value;
  };

  const getTasks = () => {
    const payload = {
      startDate: moment(selectedDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(selectedDate.endDate).format('YYYY-MM-DD'),
      page: currentPageNumber,
    };

    // Only add office_id if a specific office is selected (not "All Offices")
    if (
      selectedOffice &&
      selectedOffice.value &&
      !selectedOffice.isAllOffices
    ) {
      payload.office_id = selectedOffice.value;
    }

    if (selectedPublicZone && selectedPublicZone.value) {
      payload.public_zone_id = selectedPublicZone.value;
    }
    if (selectedSubTask && selectedSubTask.code) {
      payload.default_sub_task_code = selectedSubTask.code;
    }
    if (selectedLocation && selectedLocation.value) {
      payload.location_id = selectedLocation.value;
    }
    if (selectedMember && selectedMember.id) {
      payload.assignee_id = selectedMember.id;
    }
    if (searchTerm && searchTerm.trim()) {
      payload.task_name = searchTerm.toLowerCase().trim();
    }
    if (taskStatus && taskStatus.value && taskStatus.value !== 'all') {
      payload.status = taskStatus.value;
    }
    if (subTaskCode && subTaskCode.trim()) {
      payload.default_sub_task_code = subTaskCode.trim();
    }
    if (notUpdatedSince5Days) {
      payload.not_updated_since_days = 5;
    }
    if (selectedMainTask?.value) {
      payload.master_task_id = selectedMainTask.value;
    }
    if (notUpdatedAtAll) {
      payload.not_updated_at_all = notUpdatedAtAll;
    }

    // Remove null or undefined properties
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v != null),
    );

    getSubTasks(filteredPayload);
  };



  useEffect(() => {
    getTasks();
  }, [
    currentPageNumber,
    selectedDate,
    selectedOffice,
    selectedMember,
    // searchTerm,
    search,
    taskStatus,
    selectedLocation,
    selectedPublicZone,
    selectedSubTask,
    selectedMainTask,
    notUpdatedSince5Days,
    notUpdatedAtAll,
  ]);

  if (subTaskId) {
    return <SubTaskDetailsContainer id={subTaskId} history={history} />;
  }

  return (
    <div className="content">
      <DeleteTaskModal
        isOpen={isOpen}
        toggle={() => toggleDeleteModal()}
        handleDelete={handleDeleteTask}
        isLoading={deleteIsLoading}
      />
      <CommonGrid alignItem="center">
        <PageTitle>{t('all_sub_tasks')}</PageTitle>{' '}
        <CommonFlex gap="12px">
          {localStorage.getItem('user_role') !== 'employee' ? (
            <>
            <WhiteButtonWithIcon
                onClick={handleExportOfficeSubtaskReport}
                color="#19AC65"
                borderColor="#19AC65"
                hoverBorderColor="#129652"
                padding={exportAllSubtaskPublicZoneReportLoading ? '0 45px' : '0 25px'}
                disabled={exportAllSubtaskPublicZoneReportLoading || isOfficeExportDisabled()}
              >
                {exportAllSubtaskPublicZoneReportLoading ? (
                  <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
                ) : (
                  <>
                    <ButtonIcon src={excelIcon} size="26px" />
                    {t('export_subtask_report')}
                  </>
                )}
              </WhiteButtonWithIcon>
              <WhiteButtonWithIcon
                onClick={() => handleExportToExcel("subtasks")}
                color="#19AC65"
                borderColor="#19AC65"
                hoverBorderColor="#129652"
                padding={subTaskReportLoading ? '0 45px' : '0 25px'}
              >
                {subTaskReportLoading ? (
                  <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
                ) : (
                  <>
                    <ButtonIcon src={excelIcon} size="26px" />
                    {t('export_report')}
                  </>
                )}
              </WhiteButtonWithIcon>
              
            </>
          ) : null}
        </CommonFlex>
      </CommonGrid>
      <HeaderContainer columns="1fr">
        <SubTaskFilter
          getOrganizationMembersList={getOrganizationMembersList}
          organizationMembersList={orgMembersList}
          officesShortList={[
            // { name: allOfficesOption.label, id: 'all' },
            ...officesShortList,
          ]}
          getOfficesShortList={getOfficesShortList}
          selectedOffice={currentOffice}
          selectOffice={selectOffice}
          selectAllOffices={selectAllOffices}
          locationList={locationsList}
          selectedLocation={currentLocation}
          selectLocation={selectLocation}
          selectedMember={selectedMember}
          selectMember={selectMember}
          clearMember={clearMember}
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          taskStatus={currentStatus}
          selectedDate={selectedDate}
          startDate={selectedDate.startDate}
          endDate={selectedDate.endDate}
          handleDateChange={handleDateChange}
          handleStatusChange={handleStatusChange}
          handleSearchByName={handleSearchByName}
          handleClearSearch={handleClearSearch}
          selectedPublicZone={currentPublicZone}
          onPublicZoneChange={onPublicZoneChange}
          publicZoneList={publicZoneList}
          getTaskLocation={getTaskLocation}
          defaultSubTasks={defaultSubTasks}
          selectedSubTask={currentSubTask}
          onSubTaskChange={onSubTaskChange}
          subTaskCode={subTaskCode}
          setSubTaskCode={setSubTaskCode}
          notUpdatedSince5Days={notUpdatedSince5Days}
          onNotUpdatedSince5DaysToggle={() => setNotUpdatedSince5Days(prev => !prev)}
          notUpdatedAtAll={notUpdatedAtAll}
          onNotUpdatedAtAllToggle={() => setNotUpdatedAtAll(prev => !prev)}
          mainTaskList={mainTaskList}
          selectedMainTask={currentMainTask}
          setSelectedMainTask={setSelectedMainTask}
        />
      </HeaderContainer>

      {totalTasksCount && totalTasksCount > 0 && pageSize ? (
        <TopPagination
          itemName={t('Tasks')}
          totalCount={totalTasksCount}
          currentPage={currentPageNumber}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}

      <SubTasksList
        selectedOrganization={selectedOrganization}
        loadingTaskAssigneeId={loadingTaskAssigneeId}
        expandedTaskId={expandedTaskId}
        setExpandedTaskId={setExpandedTaskId}
        toggleDeleteModal={toggleDeleteModal}
        history={history}
        subTasksList={subTasksList}
        isLoading={isLoading}
        createTask={createTask}
      />

      {totalTasksCount && totalTasksCount > 0 && pageSize ? (
        <BottomPagination
          totalCount={totalTasksCount}
          currentPage={currentPageNumber}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}
    </div>
  );
};

export default SubTasks;
